var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_846_4231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 18C6 11.3726 11.3726 6 18 6L34 6C40.6274 6 46 11.3726 46 18V34C46 40.6274 40.6274 46 34 46H18C11.3726 46 6 40.6274 6 34V18Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.2589 32.8064L26.0006 32.6502L25.7421 32.8059L20.084 36.2145L20.0831 36.215C19.4273 36.6119 18.6245 36.0273 18.7975 35.2835L20.2972 28.8485L20.3657 28.5547L20.1377 28.3571L15.134 24.0215L15.1338 24.0213C14.5536 23.5191 14.8686 22.5719 15.6233 22.5118L15.6233 22.5118L15.626 22.5116L22.2112 21.9526L22.5114 21.9271L22.6292 21.6499L25.206 15.5827L25.2068 15.5808C25.4988 14.885 26.5014 14.885 26.7934 15.5808L26.7941 15.5823L29.3709 21.6631L29.4886 21.9407L29.789 21.9662L36.3743 22.5252L36.3769 22.5255C37.1316 22.5855 37.4467 23.5327 36.8664 24.035L36.8663 24.0351L31.8626 28.3708L31.6346 28.5683L31.703 28.8621L33.2027 35.2972C33.2027 35.2972 33.2028 35.2973 33.2028 35.2974C33.3755 36.0411 32.5729 36.6255 31.9172 36.2286L31.917 36.2286L26.2589 32.8064Z",
    fill: "#FAFAFA",
    stroke: "#DBDBDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2589 32.8064L26.0006 32.6502L25.7421 32.8059L20.084 36.2145L20.0831 36.215C19.4273 36.6119 18.6245 36.0273 18.7975 35.2835L20.2972 28.8485L20.3657 28.5547L20.1377 28.3571L15.134 24.0215L15.1338 24.0213C14.5536 23.519 14.8686 22.5718 15.6233 22.5118L15.6233 22.5118L15.626 22.5116L22.2112 21.9526L22.5114 21.9271L22.6292 21.6499L25.206 15.5827L25.2068 15.5807C25.4988 14.885 26.5014 14.885 26.7934 15.5808L26.7941 15.5823L29.3709 21.6631L29.4886 21.9407L29.789 21.9662L36.3743 22.5252L36.3769 22.5254C37.1316 22.5855 37.4467 23.5327 36.8664 24.035L36.8663 24.0351L31.8626 28.3707L31.6346 28.5683L31.703 28.8621L33.2027 35.2972C33.2027 35.2972 33.2028 35.2973 33.2028 35.2974C33.3755 36.041 32.5729 36.6255 31.9172 36.2286L31.917 36.2286L26.2589 32.8064Z",
    stroke: "#CCCCCC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_846_4231",
    x: 0,
    y: 0,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_846_4231"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_846_4231",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/BookmarkIcon.dca1c82e504587fdacf1da8b1defbc91.svg";
export { ForwardRef as ReactComponent };